import styles from './ConfirmRescue.module.css';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { Button } from '../../components/Button';
import { ButtonBack } from '../../components/ButtonBack';
import { Card } from '../../components/Card';
import { Input } from '../../components/forms/Input';
import { HelmetComponent } from '../../components/Helmet';
import { List, ListItem } from '../../components/List';
import { Notify, NotifyUpdate } from '../../components/Notify';
import { ModalCongratsRescue } from './components/ModalCongratsRescue';

import { Banks } from '../../constants/Banks';
import * as routes from '../../constants/Routes';
import { useAuth } from '../../hooks/useAuth';
import { useCart } from '../../hooks/useCart';
import { api } from '../../server/api';
import { MaskCNPJ, MaskCPF, maskTEL } from '../../utils/mask';

import bankImage from '../../assets/images/bank.png';
import pixImage from '../../assets/images/pix.png';
import { usePoints } from '../../hooks/usePoints';

interface FormValues {
  pixkey: string;
  name: string;
  cpf: string;
  birth: string;
  digitAgency: string;
  digitCount: string;
  bank: string;
  accountType: string;
  labelBank: string;
  agency: string;
  conta: string;
  cep: string;
  street: string;
  complement: string;
  neighborhood: string;
  city: string;
  state: string;
  number: string;
}

export function ConfirmRescue() {
  const navigate = useNavigate();
  const { client, player } = useAuth();
  const { availableToRedeem } = usePoints();

  const {
    cart,
    isAwardMoney,
    totalPaymentValue,
    totalPremiumPrice,
    isAwardVariable,
    clearCart,
  } = useCart();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm<FormValues>();

  const [paymentMethod, setPaymentMethod] = useState('');
  const [typePix, setTypePix] = useState('');
  const [maxLength, setMaxLength] = useState<number | undefined>(undefined);
  const [modalCongratsIsOpen, setModalCongratsIsOpen] = useState(false);

  const registerGamifiedRescue = async (
    deliverAddress: any,
    accountData: any
  ) => {
    const nId = Notify('Aguarde... registrando seu resgate...', 'loading');

    const parameters = {
      searchFunctionality:
        client.clientUrl === 'reisdopedaco'
          ? 'registerGamifiedRescueTyped'
          : 'registerGamifiedRescue',
      userType: 'player',
      cart,
      client,
      clientUrl: client.clientUrl,
      total:
        client.rescueByGoals === 'true'
          ? 0
          : isAwardMoney
            ? isAwardVariable
              ? availableToRedeem
              : totalPaymentValue
            : totalPremiumPrice,
      deliverAddress,
      accountData,
      clientId: client.id,
    };

    const responseStockAward = await api.post('/search', parameters);

    if (responseStockAward.data.success) {
      NotifyUpdate(responseStockAward.data.message, 'success', nId);
      toggleModal();
    } else {
      NotifyUpdate(responseStockAward.data.message, 'error', nId);
    }
  };

  const checkStock = async (deliverAddress: any, accountData: any) => {
    const nId = Notify('Aguarde... registrando seu resgate...', 'loading');

    const parameters = {
      searchFunctionality: 'checkStockAward',
      userType: 'player',
      cart,
      total:
        client.rescueByGoals === 'true'
          ? 0
          : isAwardVariable
            ? availableToRedeem
            : totalPremiumPrice,
      totalPaymentValue: isAwardMoney
        ? isAwardVariable
          ? availableToRedeem
          : totalPaymentValue
        : 0,
      deliverAddress,
      accountData,
      clientId: client.id,
    };

    const responseStockAward = await api.post('/search', parameters);

    if (responseStockAward.data.success) {
      NotifyUpdate(responseStockAward.data.message, 'success', nId);
      toggleModal();
    }
  };

  const handleForm = handleSubmit(async (formData) => {
    try {
      const isAwardVoucher = cart.some(
        (item) =>
          item.premiumType.value === 'digital' ||
          item.premiumType.value === 'Digital'
      );

      const {
        pixkey,
        name,
        cpf,
        digitAgency,
        digitCount,
        bank,
        accountType,
        labelBank,
        agency,
        conta,
        cep,
        street,
        complement,
        neighborhood,
        city,
        state,
        number,
      } = formData;

      if (paymentMethod === 'ted') {
        if (player.cpf.replace(/\D/g, '') !== cpf.replace(/\D/g, '')) {
          return Notify(`O cpf não corresponde`, 'warn');
        }
      } else {
        if (typePix === 'CPF') {
          if (player.cpf.replace(/\D/g, '') !== pixkey.replace(/\D/g, '')) {
            return Notify(`O cpf não corresponde`, 'warn');
          }
        }
      }

      const deliverAddress = {
        cep,
        street,
        complement,
        neighborhood,
        city,
        state,
        number,
      };

      const ted = {
        name,
        cpf,
        bank,
        labelBank,
        conta,
        agency,
        accountType,
        digitAgency,
        digitCount,
        paymentMethod,
      };
      const pix = {
        pixkey: pixkey,
        paymentMethod,
        typePix,
      };
      const accountData = paymentMethod === 'ted' ? ted : pix;

      const nId = isAwardMoney
        ? Notify('Atualizando dados bancários...', 'loading')
        : Notify('Atualizando dados...', 'loading');

      const parameters = {
        updateFunctionality: 'updateAddressPlayer',
        userType: 'player',
        deliverAddress,
        accountData,
        clientId: client.id,
      };

      const responseAddress = await api.post('update', parameters);
      if (!responseAddress.data.success) {
        return NotifyUpdate(responseAddress.data.message, 'error', nId);
      }
      NotifyUpdate(responseAddress.data.message, 'success', nId);

      if (client.isGamified === 'true') {
        await registerGamifiedRescue(deliverAddress, accountData);
      } else {
        await checkStock(deliverAddress, accountData);
      }

      if (isAwardVoucher) {
        clearCart();
        navigate(routes.MY_RESCUES);
      }
    } catch (error) {
      console.log('erro handleForm', error);
    }
  });

  const verifyDisabled = () => {
    if (!paymentMethod) {
      return true;
    }

    if (paymentMethod === `pix` && !typePix) {
      return true;
    }
    return false;
  };

  const onHandleCancelRescue = () => {
    navigate(routes.REDEEM_AWARDS);
  };

  const handleChange = (type: string) => {
    //929.324.090-42 cpf 14
    //77.996.783/0001-30 cnpj 18
    //(86) 99979-7405 telefone 15
    //2772b87c-b909-4e42-903b-4eab0ff57fff chave aleatória 32
    if (type === 'CPF') {
      setTypePix('CPF');
      setMaxLength(14);
      setValue('pixkey', '');
    }
    if (type === 'CNPJ') {
      setTypePix('CNPJ');
      setMaxLength(18);
      setValue('pixkey', '');
    }
    if (type === 'TELEFONE') {
      setTypePix('TELEFONE');
      setMaxLength(15);
      setValue('pixkey', '');
    }
    if (type === 'CHAVE_ALEATORIA') {
      setTypePix('CHAVE_ALEATORIA');
      setMaxLength(36);
      setValue('pixkey', '');
    }
    if (type === 'EMAIL') {
      setTypePix('EMAIL');
      setMaxLength(undefined);
      setValue('pixkey', '');
    }
  };

  const toggleModal = () => {
    setModalCongratsIsOpen(!modalCongratsIsOpen);
  };

  const renderEmptyCart = () => {
    return (
      <>
        <div className="container d-flex flex-column align-items-center my-5">
          {/* <img className="mr-5" src={noNotfyImage} width="300" alt="" /> */}
          <br />
          <div className="text-center">
            <h3>Ops...</h3>
            <p className="text-secondary mt-3">Seu carrinho está vazio!</p>
          </div>
        </div>
      </>
    );
  };

  const renderFormRescueMoney = () => {
    return (
      <form onSubmit={handleForm}>
        <div className="row">
          <div className="col-sm-12">
            <div className="mb-3">
              <Card>
                <>
                  <List>
                    <ListItem
                      handleChange={() => setPaymentMethod('pix')}
                      image={pixImage}
                      content="Pagamento via PIX"
                      rangeChecked={paymentMethod === 'pix'}
                      withRange={true}
                      inputType="radio"
                    />
                    <ListItem
                      handleChange={() => setPaymentMethod('ted')}
                      image={bankImage}
                      content="Pagamento via TED"
                      rangeChecked={paymentMethod === 'ted'}
                      withRange={true}
                      inputType="radio"
                    />
                  </List>
                  {paymentMethod === 'pix' && renderPaymentPix()}
                  {paymentMethod === 'ted' && renderPaymentTed()}

                  <div className="mt-3 d-flex flex-row-reverse">
                    <Button
                      type="submit"
                      text="Finalizar resgate"
                      color="primary"
                      icon="check"
                      disabled={verifyDisabled() || isSubmitting}
                      isLoading={isSubmitting}
                    />
                    <div className="me-3">
                      <Button
                        type="button"
                        onClick={onHandleCancelRescue}
                        text="Cancelar"
                        color="flat"
                        disabled={isSubmitting}
                      />
                    </div>
                  </div>
                </>
              </Card>
            </div>
          </div>
        </div>
      </form>
    );
  };

  const renderPaymentPix = () => {
    return (
      <>
        <div className="mt-3">
          <span className="fs-4 fw-semibold">Selecione sua chave pix</span>
        </div>
        <div className="mt-3">
          <div className="row">
            <div className="col-sm-12 col-md-6">
              <List>
                <ListItem
                  handleChange={() => handleChange('CPF')}
                  icon="person"
                  content="CPF"
                  rangeChecked={typePix === 'CPF'}
                  withRange={true}
                />
                <ListItem
                  handleChange={() => handleChange('CNPJ')}
                  icon="business"
                  content="CNPJ"
                  rangeChecked={typePix === 'CNPJ'}
                  withRange={true}
                />
                <ListItem
                  handleChange={() => handleChange('TELEFONE')}
                  icon="phone"
                  content="Telefone"
                  rangeChecked={typePix === 'TELEFONE'}
                  withRange={true}
                />
                <ListItem
                  handleChange={() => handleChange('EMAIL')}
                  icon="mail"
                  content="E-mail"
                  rangeChecked={typePix === 'EMAIL'}
                  withRange={true}
                />
                <ListItem
                  handleChange={() => handleChange('CHAVE_ALEATORIA')}
                  icon="format_color_text"
                  content="Chave aleatória"
                  rangeChecked={typePix === 'CHAVE_ALEATORIA'}
                  withRange={true}
                />
              </List>
            </div>
            <div className="col-sm-12 col-md-6">
              <div className="my-3">
                <Input
                  maxLength={maxLength}
                  type="text"
                  label="Chave PIX"
                  placeholder={
                    typePix === 'CHAVE_ALEATORIA'
                      ? 'Copie e cole aqui'
                      : 'Digite sua chave Pix'
                  }
                  disabled={!typePix}
                  readOnly={!typePix}
                  {...register('pixkey', {
                    required: true,
                    pattern: {
                      value:
                        typePix === 'EMAIL'
                          ? /^[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,}$/i
                          : /./,
                      message:
                        typePix === 'EMAIL' ? 'invalid email address' : '',
                    },
                  })}
                  errors={errors.pixkey ? 'Campo obrigatório' : ''}
                  onChange={(event) => {
                    const { value } = event.target;
                    if (typePix === 'CPF') {
                      if (value.length <= 14) {
                        event.target.value = MaskCPF(value);
                      }
                    }
                    if (typePix === 'CNPJ') {
                      if (value.length > 14) {
                        event.target.value = MaskCNPJ(value);
                      }
                    }
                    if (typePix === 'TELEFONE') {
                      event.target.value = maskTEL(value);
                    }
                    if (typePix === 'CHAVE_ALEATORIA') {
                      event.target.value = value;
                    }
                    if (typePix === 'EMAIL') {
                      event.target.value = value;
                    }
                  }}
                />
              </div>
              <div className="mt-3">
                <div className="alert alert-warning" role="alert">
                  <h4 className="alert-heading">Informação sobre o resgate</h4>
                  <br />
                  <ul>
                    <li>
                      Os dados de resgate via PIX ou TED, devem corresponder ao
                      mesmo CPF ou CNPJ do usuário cadastrado na plataforma.
                    </li>
                    <li>
                      Não é permitido utilizar contas de terceiros para realizar
                      o resgate.
                    </li>
                    <li>
                      Informe seus dados de resgate{' '}
                      <strong>corretamente</strong> e revise-os antes de
                      finalizar o resgate.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const renderPaymentTed = () => {
    return (
      <>
        <div className="mt-3">
          <span className="fs-4 fw-semibold">
            Preencha seus dados bancários
          </span>
        </div>
        <div className="mt-3">
          <div className="row">
            <div className="col-sm-12 col-md-6">
              <Input
                type="text"
                label="Nome"
                placeholder="Digite seu Nome"
                {...register('name', {
                  required: true,
                })}
                errors={errors.name ? 'Campo obrigatório' : ''}
              />
            </div>
            <div className="col-sm-12 col-md-6">
              <Input
                maxLength={14}
                type="text"
                label="CPF"
                placeholder="Digite seu CPF"
                {...register('cpf', {
                  required: true,
                })}
                errors={errors.cpf ? 'Campo obrigatório' : ''}
                onChange={(event) => {
                  const { value } = event.target;

                  if (value.length <= 14) {
                    event.target.value = MaskCPF(value);
                  }
                }}
              />
            </div>
            <div className="col-sm-12 col-md-6">
              <label htmlFor="accountType">Tipo de conta</label>
              <select
                className={`${styles.select}`}
                {...register('accountType', {
                  required: true,
                })}
                aria-invalid={errors.accountType ? 'true' : 'false'}
              >
                <option value="">Selecione o tipo de conta</option>
                <option value="CONTA_CORRENTE">Conta Corrente</option>
                <option value="CONTA_POUPANCA">Conta Poupança</option>
                <option value="CONTA_FACIL">Conta Fácil</option>
                <option value="ENTIDADES_PUBLICAS">Entidades Públicas</option>
              </select>
              <span className={styles.error}>
                {errors.accountType ? 'Campo obrigatório' : ''}
              </span>
            </div>
            <div className="col-sm-12 col-md-6">
              <label htmlFor="bank">Tipo de conta</label>
              <select
                className={`${styles.select}`}
                {...register('bank', {
                  required: true,
                })}
                aria-invalid={errors.bank ? 'true' : 'false'}
                onChange={(e) => {
                  const labelBank =
                    e.target.options[e.target.selectedIndex].text;
                  setValue(`bank`, e.target.value);
                  setValue(`labelBank`, labelBank);
                }}
              >
                <option value="">Escolha seu banco</option>
                {Banks.map((b) => {
                  return (
                    <option key={b.value} value={b.value}>
                      {b.value} - {b.label}
                    </option>
                  );
                })}
              </select>
              <span className={styles.error}>
                {errors.accountType ? 'Campo obrigatório' : ''}
              </span>
            </div>
            <div className="col-sm-12 col-md-6">
              <div className="row">
                <div className="col-6">
                  <Input
                    type="text"
                    label="Número da conta"
                    placeholder="Digite o número da conta"
                    {...register('conta', {
                      required: true,
                    })}
                    errors={errors.conta ? 'Campo obrigatório' : ''}
                    maxLength={13}
                  />
                </div>
                <div className="col-6">
                  <Input
                    type="text"
                    label="Dígito da conta"
                    placeholder="Digite o dígito da conta"
                    {...register('digitCount', {
                      required: true,
                    })}
                    errors={errors.digitCount ? 'Campo obrigatório' : ''}
                    maxLength={1}
                  />
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-md-6">
              <div className="row">
                <div className="col-6">
                  <Input
                    type="text"
                    label="Número da agência"
                    placeholder="Digite o número da agência"
                    {...register('agency', {
                      required: true,
                    })}
                    errors={errors.agency ? 'Campo obrigatório' : ''}
                    maxLength={4}
                  />
                </div>
                <div className="col-6">
                  <Input
                    type="text"
                    label="Dígito da agência"
                    placeholder="Digite o dígito da agência"
                    {...register('digitAgency', {
                      required: true,
                    })}
                    errors={errors.digitAgency ? 'Campo obrigatório' : ''}
                    maxLength={1}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="mt-3">
            <div className="alert alert-warning" role="alert">
              <h4 className="alert-heading">Informação sobre o resgate</h4>
              <br />
              <ul>
                <li>
                  Os dados de resgate via PIX ou TED, devem corresponder ao
                  mesmo CPF ou CNPJ do usuário cadastrado na plataforma.
                </li>
                <li>
                  Não é permitido utilizar contas de terceiros para realizar o
                  resgate.
                </li>
                <li>
                  Informe seus dados de resgate <strong>corretamente</strong> e
                  revise-os antes de finalizar o resgate.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </>
    );
  };

  /*
  João, novo layout para essa função renderFormRescueVoucherOrPhisic2
  */
  const renderFormRescueVoucherOrPhisic2 = () => {
    return (
      <form onSubmit={handleForm}>
        <div className="row">
          <div className="col-sm-12">
            <Card>
              <>
                <div className="mb-3">
                  <span className="fs-4 fw-semibold">Você está resgatando</span>
                </div>
                {cart &&
                  cart.map((award: any) => (
                    <List>
                      <ListItem
                        image={award.premiumImage}
                        content={award.premiumName}
                        secondaryContent={
                          award.amount === 1
                            ? `${award.amount} item`
                            : `${award.amount} itens`
                        }
                      />
                    </List>
                  ))}

                <div className="mt-3 d-flex flex-row-reverse">
                  <Button
                    disabled={isSubmitting}
                    type="submit"
                    text="Finalizar resgate"
                    color="primary"
                    icon="check"
                  />
                  <div className="me-3">
                    <Button
                      type="button"
                      onClick={onHandleCancelRescue}
                      text="Cancelar"
                      color="flat"
                      disabled={isSubmitting}
                    />
                  </div>
                </div>
              </>
            </Card>
          </div>
        </div>
      </form>
    );
  };

  return (
    <>
      <HelmetComponent
        clientLogoURL={client?.logoURL}
        companyName={client?.companyName}
        clientFavicon={client?.favIcon}
        primaryColor={client?.primaryColor}
        secondaryColor={client?.secondaryColor}
        tabTitle={'Confirmar resgate'}
      />
      <div className="container">
        <div className="row mb-3">
          <ButtonBack title="Confirmar/Finalizar resgate" />
        </div>
        {!cart || cart.length === 0 ? (
          renderEmptyCart()
        ) : (
          <>
            {/* FORMULÁRIO FORMULÁRIO TIPO DINHEIRO  */}
            {isAwardMoney && renderFormRescueMoney()}

            {/* FORMULÁRIO DE PREMIOS FISICOS */}
            {!isAwardMoney && renderFormRescueVoucherOrPhisic2()}
          </>
        )}

        <ModalCongratsRescue
          modalCongratsIsOpen={modalCongratsIsOpen}
          clientNumberOfDaysToRedeem={
            client && client.numberOfDaysToRedeem
              ? `até ${client.numberOfDaysToRedeem} dias úteis`
              : 'alguns dias'
          }
        />
      </div>
    </>
  );
}
